export default "__VITE_ASSET__xQoJdJB4__"